import React, { useEffect, useRef, useState } from 'react';
import './Webcam.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:6767';
const FRAME_INTERVAL_MS = 500;

const EMOTION_EMOJI = {
  happy: '😊', neutral: '😐', sad: '😔',
  angry: '😠', fearful: '😨', disgusted: '😒', surprised: '😲',
};

function Webcam({ isRunning, stream, onStatsUpdate, backendUrl = BACKEND_URL }) {
  const videoRef  = useRef(null);
  const canvasRef = useRef(null);
  const [emotion, setEmotion] = useState('neutral');

  useEffect(() => {
    if (videoRef.current) videoRef.current.srcObject = stream || null;
  }, [stream]);

  useEffect(() => {
    if (!isRunning || !stream) return;
    const canvas = canvasRef.current;
    const video  = videoRef.current;
    if (!canvas || !video) return;
    const ctx = canvas.getContext('2d');

    const interval = setInterval(() => {
      if (!video.videoWidth) return;
      canvas.width  = video.videoWidth;
      canvas.height = video.videoHeight;
      ctx.drawImage(video, 0, 0);

      canvas.toBlob(async (blob) => {
        if (!blob) return;
        try {
          const form = new FormData();
          form.append('frame', blob, 'frame.jpg');
          const res  = await fetch(`${backendUrl}/analyze-frame`, { method: 'POST', body: form });
          if (!res.ok) return;
          const data = await res.json();
          setEmotion(data.emotion || 'neutral');
          onStatsUpdate({
            emotion:      data.emotion      ?? 'neutral',
            confidence:   data.confidence   ?? 0,
            eyeContact:   data.eyeContact   ?? 75,
            wpm:          data.wpm          ?? 0,
            nervousness:  data.nervousness  ?? 0,
            fillerWords:  data.fillerWords  ?? 0,
            silence:      data.silence      ?? 0,
            issues:       data.issues       ?? {},
            interruption: data.interruption ?? null,
          });
        } catch {}
      }, 'image/jpeg', 0.8);
    }, FRAME_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [isRunning, stream, onStatsUpdate, backendUrl]);

  useEffect(() => {
    if (!isRunning) setEmotion('neutral');
  }, [isRunning]);

  return (
    <div className="webcam-container">
      {stream ? (
        <>
          <video ref={videoRef} autoPlay playsInline muted
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />

          <div className="cam-emotion-badge">
            {EMOTION_EMOJI[emotion] || '😐'} {emotion}
          </div>

          {isRunning && (
            <div className="cam-rec-badge">
              <span className="rec-pulse" /> REC
            </div>
          )}
        </>
      ) : (
        <div className="webcam-placeholder">
          <div className="placeholder-icon">📷</div>
          <p>camera will appear here</p>
        </div>
      )}
      <canvas ref={canvasRef} style={{ display: 'none' }} />
    </div>
  );
}

export default Webcam;
